import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getLamp(context) {
      let response = await Vue.axios.get(
        `${URL_API}architecture/getbytype?architecture_type_id=5`
      );
      let data = response["data"];
      context.commit("updateLamp", data);
      return data;
    }
  },
  mutations: {
    updateLamp(state, data) {
      state.lamp = data;
    }
  },
  state: {
    lamp: {}
  },
  getters: {
    allLamp(state) {
      return state.lamp;
    }
  }
};
